import { Injectable } from "@angular/core";
import {
    Resolve,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    ActivatedRoute,
    Router
} from "@angular/router";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserService } from './user.service';
import { WalletService } from './wallet.service';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { CustomUrlSerializer } from '../shared/models/UrlSerializer/custom-url-serializer';
declare var $: any;
@Injectable({
    providedIn: "root"
})
export class ResolverService implements Resolve<any> {
    unsubscribe$: Subject<void> = new Subject<void>();
    constructor(
        private userService: UserService,
        private activeRouter: ActivatedRoute,
        private walletService: WalletService,
        private router: Router,
        private cookieService: CookieService
    ) { }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return await this.getParams();
    }
    logOut() {
        if (!environment.production)
            console.log('logout')
        $('.modal').modal('hide');
        this.userService.deleteUserData();
        this.userService.deleteToken();
        this.userService.setUserData({});
        this.userService.setToken('');
        this.userService.isLoggedIn = false;
        localStorage.removeItem('tokenApp')
        if (!environment.production)
            console.log('RESOLVER 42: HIT LOG OUT EVENT');
        this.userService.logOutEventHit();
    }
    getParams() {
        return new Promise((resolve, reject) => {
            if (!localStorage.getItem('OBSIDIAM-LOCAL-CURRENCIES')) {
                this.walletService.getCurrencies().toPromise().then((m: any) => {
                    if (m.status === 200) {
                        localStorage.setItem('OBSIDIAM-LOCAL-CURRENCIES', JSON.stringify(m.data));
                    }
                    let parameters = new URLSearchParams(window.location.search);
                    this.activeRouter.queryParams.pipe(takeUntil(this.unsubscribe$)).subscribe((a) => {
                        // console.log(a)
                        let token = a.token || this.userService.getParameterByName('token') || parameters.get('token');
                        // if (!environment.production)
                            // console.log('authguard', token, window.location.href, CustomUrlSerializer.decript(this.router.url), this.userService.isLoggedIn);
                        if (token) {
                            this.userService.getProfileData(token).pipe(takeUntil(this.unsubscribe$)).toPromise().then((a: any) => {
                                if (a.status === 200) {
                                    let tokenData = { token: token, createdAt: new Date() }
                                    const currency = m.data.find((a1) => a1.shortName === a.data.preferredCurrency);
                                    a.data.preferredCurrency = currency || {};
                                    let data = { ...a.data, ...tokenData };
                                    this.userService.setToken(token);
                                    this.userService.setUserData(data, true);
                                    this.userService.startTokenTime();
                                    this.userService.isLoggedIn = true;
                                    this.userService.changeUserData();
                                    resolve(true)
                                } else {
                                    resolve(false);
                                }
                            })
                        } else {
                            resolve(true)
                        }
                    })


                });
            } else {
                let curen: any = localStorage.getItem('OBSIDIAM-LOCAL-CURRENCIES');
                curen = curen ? JSON.parse(curen) : []

                let parameters = new URLSearchParams(window.location.search);
                this.activeRouter.queryParams.pipe(takeUntil(this.unsubscribe$)).subscribe((a) => {
                    // console.log(a)
                    let token = a.token || this.userService.getParameterByName('token') || parameters.get('token');
                    if (token) {
                        this.userService.getProfileData(token).pipe(takeUntil(this.unsubscribe$)).toPromise().then((a: any) => {
                            if (a.status === 200) {
                                let tokenData = { token: token, createdAt: new Date() }
                                const currency = curen.find((a1) => a1.shortName === a.data.preferredCurrency);
                                a.data.preferredCurrency = currency || {};
                                let data = { ...a.data, ...tokenData };
                                this.userService.setToken(token);
                                this.userService.setUserData(data, true);
                                this.userService.startTokenTime();
                                this.userService.isLoggedIn = true;
                                this.userService.changeUserData();
                                resolve(true)
                            } else {
                                resolve(false);
                            }
                        })
                    } else {
                        resolve(true)
                    }
                });
            }
        });
    }
}
